/**
 * Taxonomy actions.
 * @module actions/taxonomies/taxonomies
 */

import { LOAD_TAXONOMY } from '../../constants/ActionTypes';

/**
 * Load taxonomy terms.
 * @function loadTaxonomy
 * @param {string} taxonomyName The name of the taxonomy to load.
 * @returns {Object} taxonomies action.
 */
export function loadTaxonomy(taxonomyName) {
  return {
    type: LOAD_TAXONOMY,
    taxonomy: taxonomyName,
    request: {
      op: 'get',
      path: taxonomyName ? `/@taxonomy/${taxonomyName}` : '/@taxonomy',
    },
  };
}
